import { Box, CircularProgress } from '@mui/material'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useMe } from '@/api/session'

/**
 * Wraps everything a manager touches.
 *
 * The redirect carries `next`, because arriving at a campaign link while
 * signed out and being dumped on the dashboard after signing in is the
 * fastest way to lose somebody who was one tap from clearing their share.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const me = useMe()
  const location = useLocation()

  if (me.isPending) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <CircularProgress size={22} />
      </Box>
    )
  }

  if (!me.data?.signed_in) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/signin?next=${next}`} replace />
  }

  return <>{children}</>
}
